import { AbstractView } from "@lib/titan2/dist/game/view/AbstractView";
/**
 * AbstractGameView.ts
 */
export class AbstractGameView extends AbstractView {
    constructor(factory, properties, portraitProperties) {
        super(properties, portraitProperties);
        this.createFactory(factory);
        this.operatorConfig = factory.getOperatorConfig();
        //this.gameConfig = <ISlingoClientConfig> factory.getGameConfig();
        this.run();
    }
    createProperties(landscapeProperties, portraitProperties) {
        super.createProperties(landscapeProperties, portraitProperties);
        this.responsive = true;
    }
    createFactory(factory) {
        this.factory = factory;
    }
    createModel() {
        this.model = this.factory.getModel();
        this.responsibleGaming = this.model.getResponsibleGaming();
    }
    registerGame(event, handler) {
        this.model.register(event, handler, this);
    }
    unregisterGame(event) {
        this.model.unregister(event, this);
    }
    dispatchGame(event) {
        this.model.dispatch(event);
    }
}
//# sourceMappingURL=AbstractGameView.js.map